import { createContext, useContext, useState } from 'react';
import { defaultData as defaultFlightSearchReq } from '../components/air/AirSearchForm/constants';

const MyContext = createContext(null);

export function MyProvider({ children }) {
    //Global state to make the search form data available to all components
    const [flightSearchReq, setFlightSearchReq] = useState(defaultFlightSearchReq);

    const value = {
        flightSearchReq,
        setFlightSearchReq,
    };

    return <MyContext.Provider value={value}>{children}</MyContext.Provider>;
}

export const useMyContext = () => useContext(MyContext);
